import {TypeResultatAttribution} from './TypeResultatAttribution';
export class LotMarche {

	public numLot: string;

	public description: string;

	public resultat: TypeResultatAttribution;

	constructor() {
		this.numLot = '';
		this.description = '';
		this.resultat = new TypeResultatAttribution();

	}
}
